import React from "react";
import ActiveNumberHolder, { makeActiveNumber } from "./ActiveNumberHolder";

const NumberBar = ({ openObject, savedObject, numbers }) => {
  return (
    <div
      className="divRow"
      style={{
        width: "100%",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      {numbers.map((object) => (
        <ActiveNumberHolder {...object} key={object.name} />
      ))}
    </div>
  );
};

export default NumberBar;
